import { DistributiveOmit } from '@direct-frontend/stdlib';
import { FormSliceState } from '../types';

export function getDefaultFieldState(): DistributiveOmit<
    FormSliceState['forms'][string]['fieldsState'][string],
    'order' | 'fields' | 'valuesByKey' | 'statesByKey'
> {
    const timestamp = Date.now();

    return {
        errorsMap: {
            onChange: [],
            onBlur: [],
            onSubmit: [],
        },
        isTouched: false,
        initialValue: undefined,
        validationMeta: {
            onChange: {},
            onBlur: {},
            onSubmit: {},
        },
        asyncActionsMeta: {},
        parentId: undefined,
        modifiedAt: timestamp,
    };
}
